import React, { useState } from 'react'
import Tooltip from '../../components/Tooltip/Tooltip'
import Avatar from '@components/Avatar'
import TooltipContent from './TooltipContent'
import EmployeeInitials from '@components/EmployeeInitials'
import {
  ClickAwayListener,
  TextField,
  InputAdornment,
  Tooltip as TooltipMUI
} from '@material-ui/core'
import Trash from '../../components/Icon/Trash'
import { Autocomplete } from '@material-ui/lab'
import { massProcessingApi } from '@atheneum/api'
import getAdditionalEmployee from '../api/getAdditionalEmployee'
import ShareIcon from '@material-ui/icons/Share'
import SearchIcon from '@material-ui/icons/Search'

const share = async (
  dispatch,
  { id, userId, email, fullName, picture, currentPosition, firstName, lastName }
) => {
  dispatch({
    type: 'ADD_EMPLOYEE',
    payload: {
      id,
      employee: {
        userId,
        email,
        fullName,
        picture,
        currentPosition,
        firstName,
        lastName
      }
    }
  })
  await massProcessingApi.shareList({
    id,
    userId,
    email,
    fullName,
    picture,
    currentPosition,
    firstName,
    lastName
  })
}

const SharedWith = ({ allEmployees, employees, item, dispatch }) => {
  const [value] = useState(null)
  const [inputValue, setInputValue] = useState('')
  const [hoverEmployee, setHoverEmployee] = useState(0)
  const handleHoverEmployee = id => setHoverEmployee(id)

  const [open, setOpen] = React.useState(false)
  const handleClick = () => {
    setOpen(prev => !prev)
  }

  const handleClickAway = () => {
    setOpen(false)
  }

  const removeEmployee = ({ id, userId }) => {
    dispatch({ type: 'REMOVE_EMPLOYEE', payload: { id, userId } })
  }

  return (
    <div
      style={{ position: 'absolute', left: '11px', bottom: '8px' }}
      className="mass-processing-list-involvedEmployees mp-sharedWith">
      {employees.map((employee, index) => {
        const havePicture = employee.picture &&  !!employee.picture.length
        if (index < 3) {
          return havePicture ? (
            <Tooltip
              key={index}
              tooltip={TooltipContent({ employeeData: employee })}>
              <div>
                <Avatar
                  className="mass-processing-list-userAvatarSmaller"
                  alt="User avatar"
                  src={employee.picture}
                />
              </div>
            </Tooltip>
          ) : (
            <EmployeeInitials
              key={index}
              employee={{ ...employee, id: employee.userId }}
            />
          )
        }
        return null
      })}

      {employees.length > 3 && (
        <>
          <p className="mp-showAllEmployees" title="Show all employees">
            + {employees.length - 3}
          </p>
        </>
      )}
      {
        <ClickAwayListener onClickAway={handleClickAway}>
          <div>
            <TooltipMUI title="Share with other colleagues" placement="top">
              <ShareIcon
                onClick={handleClick}
                style={{
                  marginLeft: '6px',
                  cursor: 'pointer',
                  fill: '#535353'
                }}
              />
            </TooltipMUI>
            {open ? (
              <div
                style={{
                  zIndex: 2,
                  position: 'absolute',
                  background: '#fff',
                  left: 0,
                  boxShadow:
                    'rgb(0 0 0 / 20%) 0px 2px 2px 1px, rgb(0 0 0 / 14%) 0px 1px 1px 0px, rgb(0 0 0 / 12%) 0px 1px 3px 0px'
                }}>
                <div style={{ margin: '20px 8px 0 8px' }}>
                  <Autocomplete
                    value={value}
                    onChange={(_event, newValue) => {
                      setInputValue('')
                      getAdditionalEmployee(newValue.id).then(({ data }) => {
                        share(dispatch, {
                          id: item.id,
                          userId: data.id,
                          email: data.email,
                          fullName: data.fullName,
                          picture: !!data.picture?.path
                            ? data.picture.path
                            : '',
                          currentPosition: data.currentPosition,
                          firstName: data.firstName,
                          lastName: data.lastName
                        })
                      })
                    }}
                    inputValue={inputValue}
                    onInputChange={(_event, newInputValue) => {
                      setInputValue(newInputValue)
                    }}
                    options={allEmployees.filter(
                      employee =>
                        !item.sharedWith
                          .map(employee => employee.userId)
                          .includes(employee.id)
                    )}
                    getOptionLabel={option => option.name}
                    style={{ width: 300, maxHeigth: '200px' }}
                    renderInput={params => {
                      return (
                        <TextField
                          {...params}
                          placeholder="Search"
                          InputProps={{
                            ...params.InputProps,
                            startAdornment: (
                              <>
                                <InputAdornment position="start">
                                  <SearchIcon style={{ color: '#9d9d9d' }} />
                                </InputAdornment>
                                {params.InputProps.startAdornment}
                              </>
                            )
                          }}
                        />
                      )
                    }}
                  />
                </div>

                <div
                  style={{
                    margin: '0 8px'
                  }}
                  className="involvedEmployees-optionContainer">
                  {item.sharedWith.map((employee, i) => {
                    const havePicture = !!employee.picture.length
                    return (
                      <div
                        key={i}
                        className="mass-processing-list-employeeOption"
                        onMouseOver={() => handleHoverEmployee(employee.userId)}
                        onMouseLeave={() => handleHoverEmployee(0)}>
                        <p>
                          {havePicture ? (
                            <Tooltip
                              key={i}
                              tooltip={TooltipContent({
                                employeeData: employee
                              })}>
                              <div>
                                <Avatar
                                  className="mass-processing-list-userAvatar mass-processing-list-userAvatarSmall"
                                  alt="User avatar"
                                  src={employee.picture}
                                />
                              </div>
                            </Tooltip>
                          ) : (
                            <>
                              <EmployeeInitials
                                key={i}
                                employee={{ ...employee, id: employee.userId }}
                              />
                            </>
                          )}
                          <span style={{ marginLeft: '10px' }}>
                            {' '}
                            {employee.fullName}{' '}
                          </span>
                        </p>
                        {hoverEmployee === employee.userId &&
                          employee.userId !== item.owner && (
                            <button
                              className="mass-processing-list-smallTrash"
                              onClick={() =>
                                removeEmployee({
                                  id: item.id,
                                  userId: employee.userId
                                })
                              }>
                              <Trash />
                            </button>
                          )}
                      </div>
                    )
                  })}
                </div>
              </div>
            ) : null}
          </div>
        </ClickAwayListener>
      }
    </div>
  )
}

export default SharedWith
